import { Card, CardContent } from "@/components/ui/card"

export function ClassPreferenceCard({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <Card className="flex w-96 max-w-96 flex-col gap-2 px-1">
      <CardContent
        className="min-h-0 flex-1 overflow-y-auto scroll-smooth px-4"
        data-testid="preference-list"
      >
        {children}
      </CardContent>
    </Card>
  )
}
